import React from 'react';
import { Card, CardHeader, CardBody, Row, Col, FormGroup, CustomInput, Collapse, Button } from 'reactstrap';

const CustomPermissionsSection = ({
    customPermissions = {},
    basePermissions = {},
    onChange,
    isView = false
}) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const handlePermissionChange = (view, action, value) => {
        const baseValue = basePermissions[view] && basePermissions[view][action];
        const effectiveBase = baseValue === true;

        let newCustom = { ...customPermissions };

        if (!newCustom[view]) newCustom[view] = {};

        // Si el valor es igual al base, eliminar la personalización
        if (value === effectiveBase) {
            delete newCustom[view][action];
            if (Object.keys(newCustom[view]).length === 0) {
                delete newCustom[view];
            }
        } else {
            newCustom[view][action] = value;
        }

        onChange(newCustom);
    };

    const getActionLabel = (action) => {
        const labels = {
            view: 'Ver',
            create: 'Crear',
            edit: 'Editar',
            delete: 'Eliminar'
        };
        return labels[action] || action;
    };

    const renderPermissionSection = (view, label, actions = ['view', 'create', 'edit', 'delete']) => {
        const baseView = basePermissions[view] || {};
        const customView = customPermissions[view] || {};

        return (
            <Card className="mb-3">
                <CardHeader className="font-weight-bold bg-light">{label}</CardHeader>
                <CardBody>
                    <Row>
                        {actions.map(action => {
                            const baseVal = baseView[action] === true;
                            const customVal = customView[action];
                            const effectiveVal = customVal !== undefined ? customVal : baseVal;
                            const isModified = customVal !== undefined;
                            const switchId = `custom-${view}-${action}`;

                            return (
                                <Col md={3} key={action} className="mb-2">
                                    <FormGroup>
                                        <CustomInput
                                            type="switch"
                                            id={switchId}
                                            label={
                                                <span>
                                                    {getActionLabel(action)}
                                                    {isModified && <span className="text-primary font-weight-bold ml-1">*</span>}
                                                </span>
                                            }
                                            checked={effectiveVal}
                                            onChange={(e) => handlePermissionChange(view, action, e.target.checked)}
                                            disabled={isView}
                                        />
                                        <small className="text-muted ml-4 d-block" style={{ marginTop: '-0.2rem' }}>
                                            {isModified ? (
                                                effectiveVal === baseVal ? "(Redundante)" : `(Base: ${baseVal ? 'Sí' : 'No'})`
                                            ) : (
                                                `Heredado: ${baseVal ? 'Sí' : 'No'}`
                                            )}
                                        </small>
                                    </FormGroup>
                                </Col>
                            );
                        })}
                    </Row>
                </CardBody>
            </Card>
        );
    };

    return (
        <div className="mt-4">
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="pl-3">Permisos Personalizados (Opcional)</h4>
                <Button
                    color="link"
                    onClick={() => setIsOpen(!isOpen)}
                    className="mr-3"
                >
                    {isOpen ? 'Ocultar' : 'Mostrar'} <i className={`fa fa-chevron-${isOpen ? 'up' : 'down'} ml-2`}></i>
                </Button>
            </div>
            <hr className="line-detail m-3" />

            <Collapse isOpen={isOpen}>
                <div className="px-3">
                    <div className="alert alert-info mb-3">
                        <small>
                            Los permisos personalizados anulan los permisos del Rol y del Perfil de Roles.
                            <br />
                            Marcado con <span className="text-primary font-weight-bold">*</span> indica una modificación personalizada.
                        </small>
                    </div>

                    {renderPermissionSection('emergencies', 'Emergencias')}
                    {renderPermissionSection('vehicles', 'Vehículos')}
                    {renderPermissionSection('users', 'Usuarios')}
                    {renderPermissionSection('stations', 'Estaciones')}
                    {renderPermissionSection('reports', 'Reportes', ['view'])}
                    {renderPermissionSection('roles', 'Gestión de Roles', ['view', 'edit'])}
                    {renderPermissionSection('qr_scan', 'Escaneo QR')}
                </div>
            </Collapse>
        </div>
    );
};

export default CustomPermissionsSection;
